import PropTypes from 'prop-types';

export const CURRENT_USER = {
    currentUser: PropTypes.shape({
        id: PropTypes.number,
        username: PropTypes.string,
        profileImage: PropTypes.string,
        isSeller: PropTypes.bool,
        isOnline: PropTypes.bool,
    }),
};
